import { AbstractDownloadableService } from './abstract-downloadable.service';
import { ExpensesItem } from '../models';

/**
 * @class ExpensesItemPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<ExpensesItem>}
 */
export class ExpensesItemPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/expenses-item(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ExpensesItem}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ExpensesItem(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ExpensesItem>>}
     */
    get (params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ExpensesItem} expensesItem
     * @param {Property} property
     * @returns {Promise.<ExpensesItem>}
     */
    create(expensesItem, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, expensesItem.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Integer} propertyId
     * @param {Integer} expensesItemId
     * @param {Object} params
     */
    show(propertyId, expensesItemId, params = {}) {

        const url = this.url({
            propertyId: propertyId,
            id: expensesItemId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ExpensesItem} expensesItem
     * @returns {Promise.<ExpensesItem>}
     */
    update(expensesItem) {

        const url = this.url({
            propertyId: expensesItem.property_id,
            id:         expensesItem.id
        });

        return this.http
            .put(url, expensesItem.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ExpensesItem} expensesItem
     * @returns {Promise.<boolean>}
     */
    delete(expensesItem) {

        const url = this.url({
            propertyId: expensesItem.property_id,
            id:         expensesItem.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/expenses-item.service.js